"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.main = void 0;
var styles_1 = require("@material-ui/core/styles");
var colors_1 = require("./colors");
exports.main = (0, styles_1.createTheme)({
    overrides: {
        MuiCssBaseline: {
            '@global': {
                html: {
                    fontFamily: '"Inter", sans-serif',
                },
            },
        },
    },
    custom: {
        slideout: {
            bgColor: colors_1.materialColors.grey[700],
            contrastText: '#fff',
            mutedText: colors_1.materialColors.blue[200],
        },
        slideoutToggle: {
            bgColor: '#fff',
            contrastText: colors_1.materialColors.grey[800],
        },
        borders: {
            main: colors_1.materialColors.grey[100],
        },
    },
    typography: {
        fontFamily: ['"Inter"', 'sans-serif', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
    },
    palette: {
        primary: {
            light: colors_1.materialColors.blue[500],
            main: colors_1.materialColors.blue[600],
            contrastText: '#fff',
            dark: colors_1.materialColors.blue[900],
        },
        secondary: {
            main: colors_1.materialColors.yellow[500],
            contrastText: colors_1.materialColors.grey[800],
        },
        background: {
            default: colors_1.materialColors.blue[50],
        },
        text: {
            primary: colors_1.materialColors.grey[800],
            secondary: colors_1.materialColors.grey[700],
        },
        error: {
            main: colors_1.materialColors.red[500],
            light: colors_1.materialColors.red[50],
        },
    },
});
